
window.addEventListener('frame-ready', init)

function init() {

    let wrapper = document.querySelector('.country-popup-wrapper')

    if(!document.body.classList.contains('show-country-popup') || !wrapper) {
        return;
    }

    let store = window.localStorage
    let key = 'country-popup'

    // if the popup has been interacted with, dont continue
    if(store.getItem(key) == 'true') {
        return;
    }

    // show the popup
    document.body.classList.add('popup-show')

    let popup = wrapper.querySelector('.country-popup')
    let button = popup.querySelector('.country-popup--location')
    let cancel = popup.querySelector('.country-popup--cancel')
    let indicator = popup.querySelector('.country-popup--indicator span')
    let value = parseInt(indicator.innerText)
    let interval

    interval = setInterval(() => {
        if(value > 0) {
            indicator.innerText = value
            value--
        } else {
            close();
        }
    }, 1000)

    wrapper.addEventListener('click', e => {
        close()
    })

    button.addEventListener('click', e => {
        close()
    })

    // Allows clicking behind the modal to close it
    popup.addEventListener('click', e => {
        e.stopPropagation()
    })

    function close () {
        window.clearInterval(interval)
        store.setItem(key, true)
        document.body.classList.remove('popup-show')
    }
}
